import * as React from 'react';

const FlaggedStudentCompleted = () => (
  <div className="flagged-student-completed">
    <i className="fa fa-check-circle" />
    <h3>Good work!</h3>
    <p>You have just completed this lesson.</p>
    <p><span>Next:</span> Hold tight and wait for instructions from your teacher.</p>
  </div>
)

export default FlaggedStudentCompleted;
